import { render, staticRenderFns } from "./phquerys.vue?vue&type=template&id=04063a7b"
import script from "./phquerys.vue?vue&type=script&lang=js"
export * from "./phquerys.vue?vue&type=script&lang=js"
import style0 from "./phquerys.vue?vue&type=style&index=0&id=04063a7b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports